import { render, staticRenderFns } from "./BuildingTable.vue?vue&type=template&id=2b213590&scoped=true&"
import script from "./BuildingTable.vue?vue&type=script&lang=js&"
export * from "./BuildingTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b213590",
  null
  
)

export default component.exports